
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XHeader,
Group,
Cell,
XButton
},
data() {
return {
isDropping:false,
classList: []
};
},
created() {
this.getData();
},
methods: {
getData() {
this.showExerciseType = false;

this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadMyCourseList",
params: {
cusId: this.$store.getters.getUserInfo.CusId
}
})
.then(response => {
if (response.status == 200) {
this.classList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
AddCourse: function(course) {
if(this.isDropping) return;
var courseId = course.icourseid;
var courseName = course.ccoursename;

var classInfo = this.$store.getters.getClassInfo;
if (classInfo != undefined) {
classInfo.CourseId = courseId;
classInfo.CourseName = courseName;
classInfo.IsNew = true;
this.$store.commit("$_setClassInfo", classInfo);
}

this.$http({
method: "post",
url: "wxexam.ashx?op=AddMyCourse",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: courseId
}
})
.then(response => {
if (response.status == 200) {
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$router.push('/');
},
doStartDrop(){
this.isDropping = true;
},

doCancelDrop(){
this.isDropping = false;
},
doDropMyCourse(item){
if(!item) return;
const _this = this;
this.$vux.confirm.show({
title: "确认删除",
content: "确定要删除选中的课程吗？请务必慎重操作！",
confirmText: "确认删除",
cancelText: "先不要",
onConfirm() {
_this.$http({
method: "post",
url: "wxexam.ashx?op=DeleteMyCourse",
params: {
cusId: _this.$store.getters.getUserInfo.CusId,
courseId: item.icourseid
}
})
.then(response => {
if (response.data.errcode == 0) {

for(var i=_this.classList.length - 1;i>=0;i--){
if(_this.classList[i].icourseid == item.icourseid){
_this.classList.splice(i, 1);
}
}
}
else{
_this.$vux.toast.text(response.data.errmsg, "bottom");
}
})
.catch(function(error) {
console.log("error:" + error);
});

},
});

},
}
};



// WEBPACK FOOTER //
// ./src/components/MyClassList.vue